<template>
  <div>
    <el-popover
      placement="bottom"
      width="800"
      ref="rate-detail-popover">
      <div class="content-wrapper">
        <div class="page-header">
          {{ $t('viewRate') }}
          <small>
            {{ rateCode.code }}/{{ rateCode.name }}
          </small>
        </div>
        <popover-container :loadingStatus="isLoading">
          <div v-if="periodList.length > 0">
            <table class="table-rate-detail" border="0" cellspacing="0" cellpadding="0">
              <tr class="table-rate-detail-header">
                <td width="25%"> &nbsp; </td>
                <td valign="bottom" :width="tableColWidth+'%'"
                    v-for="(roomTypeItem, roomTypeIdIndex) of selectRoomTypeList" :key="roomTypeIdIndex">
                  <div
                    class="el-input el-input--small"
                    :class="{ disable: (roomTypeListById[roomTypeItem.id].isEnable === STATUS.DISABLE)}">
                    {{ (roomTypeListById[roomTypeItem.id].isEnable === STATUS.ENABLE) ? '' : `[${$t('STATUS.DISABLE')}]` }} {{roomTypeItem.name}}
                  </div>
                </td>
              </tr>
              <tr v-for="(period, index) in periodList" :key="index">
                <td width="25%">
                  <span class="period-date">
                  {{ bindPeriod(period) }}
                </span>
                </td>
                <td :width="tableColWidth+'%'"
                    v-for="(roomTypeItem, roomTypeIdIndex) of selectRoomTypeList" :key="`${roomTypeItem.id}-${roomTypeIdIndex}`">
                  <div class="el-input el-input--small">
                    {{ bindPrice(roomTypeItem.id, index) }}
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <div v-if="periodList.length === 0" class="empty-period-list">
            <span>{{$t('viewRateEmptyPeriodList')}}</span>
          </div>
        </popover-container>
      </div>
    </el-popover>
    <el-button v-popover:rate-detail-popover
               size="mini"
               slot="reference"
               type="primary"
               @click="onViewRateButtonClick(rateCode.id)"
               plain>{{ $t('viewRate') }}</el-button>
  </div>
</template>

<script>
import { STATUS } from '@/configs/constant'
import i18nMessages from '@/translations/Hotel/ManageHotel/RateCode/List.i18n'
import PopoverContainer from '@/components/PopoverContainerComponent.vue'
import HotelRateCodeApi from '@/api/hotel/rate-code-api'
import { getISODateFormat, numberFormat } from '@/helpers/index'
import { sortPeriodList, dateFormat } from '@/helpers/datetime'
import { get } from 'lodash'

export default {
  name: 'ViewRateDetailButton',
  components: { PopoverContainer },
  i18n: { messages: i18nMessages },
  model: {
    event: 'onGetDetailError'
  },
  props: {
    activeHotelId: {
      type: String,
      default: () => {
        return ''
      }
    },
    rateCodeDetailList: {
      type: Array,
      default: () => {
        return []
      }
    },
    roomTypeList: {
      type: Array,
      default: () => {
        return []
      }
    },
    rateCode: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  created: function () {
    this.prepareRoomTypeListById()
  },
  data () {
    return {
      STATUS,
      isLoading: false,
      periodList: [''],
      roomPriceList: {},
      roomTypeListById: {},
      selectRoomTypeList: [],
      tableColWidth: ''
    }
  },
  methods: {
    onViewRateButtonClick: async function (rateCodeId) {
      this.isLoading = true
      let rateCodeDetailList = []

      try {
        if (this.activeHotelId !== '') {
          rateCodeDetailList = await HotelRateCodeApi.detail(this.activeHotelId, rateCodeId)
        } else {
          rateCodeDetailList = this.rateCodeDetailList.filter(rateCodeDetail => Number(rateCodeDetail.rateCodeId) === Number(rateCodeId))
        }
      } catch (err) {
        this.$emit('onGetDetailError', err)
      }

      this.prepareRatePeriodListData(rateCodeDetailList)

      this.isLoading = false
    },
    prepareRoomTypeListById: function () {
      this.roomTypeList.map((roomType) => {
        const roomTypeId = roomType.id
        this.roomTypeListById[roomTypeId] = roomType
      })
    },
    prepareRatePeriodListData: function (rateCodeDetailList) {
      this.periodList = []
      let roomTypeIdList = []
      let index = 0

      const periodKeyList = []

      rateCodeDetailList.sort(sortPeriodList)
      rateCodeDetailList.forEach((rateCodeDetail) => {
        const startDate = getISODateFormat(new Date(rateCodeDetail.startDate))
        const endDate = getISODateFormat(new Date(rateCodeDetail.endDate))
        const roomTypeId = rateCodeDetail.roomTypeId
        const price = rateCodeDetail.price

        const periodKey = `${startDate}_${endDate}`
        const isIncludePeriod = periodKeyList.includes(periodKey)

        if (!roomTypeIdList.includes(roomTypeId)) {
          roomTypeIdList.push(roomTypeId)
        }

        if (this.roomPriceList[roomTypeId] === undefined) {
          this.roomPriceList[roomTypeId] = []
        }

        if (!isIncludePeriod) {
          this.periodList[index] = {
            startDate: startDate,
            endDate: endDate
          }
          this.roomPriceList[roomTypeId][index] = price

          periodKeyList.push(periodKey)
          index++
        } else {
          const periodIndex = periodKeyList.indexOf(periodKey)
          this.roomPriceList[roomTypeId][periodIndex] = price
        }
      })

      this.selectRoomTypeList = []
      for (let roomTypeId of roomTypeIdList) {
        if (this.roomTypeListById[roomTypeId] !== undefined) {
          const price = get(this.roomPriceList, `[${roomTypeId}][0]`, '')
          const roomTypeItem = {
            id: roomTypeId,
            name: this.roomTypeListById[roomTypeId]['name'],
            price: price
          }
          this.selectRoomTypeList.push(roomTypeItem)
        }
      }
      this.selectRoomTypeList = this.selectRoomTypeList.sort((a, b) => {
        return (a.price < b.price) ? -1 : 1
      })

      const tableColWidth = 75 / this.selectRoomTypeList.length
      this.tableColWidth = Math.ceil(tableColWidth).toString()
    },
    bindPeriod: function (period) {
      const startDate = get(period, 'startDate', null)
      const endDate = get(period, 'endDate', null)

      if (startDate === null || endDate === null) {
        return
      }

      const fromDate = new Date(startDate)
      const toDate = new Date(endDate)

      return `${dateFormat.short(fromDate)} - ${dateFormat.short(toDate)}`
    },
    bindPrice: function (roomTypeId, priceIndex) {
      const price = get(this.roomPriceList, `[${roomTypeId}][${priceIndex}]`, '')

      return (price !== '') ? numberFormat(price) : '-'
    }
  }
}
</script>

<style scoped>
  .table-rate-detail {
    width: 100%;
  }
  .table-rate-detail td {
    text-align: center;
    padding: 10px;
    border-bottom: 1px #ccc solid;
  }

  .table-rate-detail-header {
    background-color: #2376e5;
    color: #ffffff;
  }
  .el-popover.el-popper {
    padding: 0 !important;
  }
  .period-date {
    font-size: 12px;
  }
  .page-header {
    font-size: 18px;
  }
  .page-header > small {
    color: #606266;
    font-size: 12px;
    margin-left: 10px;
  }
  .el-row.table-header {
    background: #2376e5;
    color: #ffffff;
  }
  .el-row {
    border-bottom: 1px #ccc solid;
  }
  .el-col {
    padding: 10px;
  }
  .empty-period-list {
    line-height: 90px;
    text-align: center;
    font-size: 16px;
    color: #fe6c6f;
    background-color: #f9f9f9;
    font-style: italic;
  }
  .disable {
    color: #d2d1d1;
  }
</style>
